import type { Enums } from "@msuite/utils/types";
import { enumeration, number, string, table } from "@rocicorp/zero";
import { addressFields, coreFields } from "./shared";

/**
 * Tables
 */
export const project = table("projects")
	.columns({
		...coreFields,
		name: string(),
		number: string(),
		...addressFields,
		state: enumeration<Enums<"projectState">>(),
		note: string().optional(),
		workspaceId: string().from("workspace_id"),
		relatedProjectId: string().from("related_project_id").optional(),
		orgId: string().from("org_id"),
		clientId: string().from("client_id"),
		longitude: number().optional(),
		latitude: number().optional(),
	})
	.primaryKey("id");
